/** @module components/Breadcrumb */
import { Icon } from "react-aiot";
import React from "react";
var ICON_OBJ_SEP = /*#__PURE__*/React.createElement(Icon, {
  type: "right"
});
/**
 * Simple breadcrumbs with arrows and a home icon.
 *
 * @property {string[]} path The pathes
 * @type React.Element
 */

export default (function (_ref) {
  var path = _ref.path,
      _ref$closeable = _ref.closeable,
      closeable = _ref$closeable === void 0 ? false : _ref$closeable,
      onClose = _ref.onClose;
  var i = 0; // Use counter as key

  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
    type: "folder"
  }), "\xA0\xA0", path.map(function (item) {
    return /*#__PURE__*/React.createElement("span", {
      key: i++
    }, item, "\xA0", i < path.length && ICON_OBJ_SEP, "\xA0");
  }), !!closeable && /*#__PURE__*/React.createElement(Icon, {
    type: "close",
    onClick: onClose
  }));
});